<template>
    <layout>
        <TitleLable parentMessage="题库管理" :showback="true"></TitleLable>
        <el-row>
        
            <el-button size="small" @click="createQuestion" class="el-icon-edit" type="primary"> 创建题目</el-button>
            <el-button size="small" class="el-icon-upload2" type="primary" plain> 批量导入</el-button>

            <el-button @click="confirmChange" v-if="trem" size="small" class="el-icon-plus" type="danger" plain> 确认选择</el-button>
            <el-button size="small" class="el-icon-delete" type="danger"> 删除</el-button>

        </el-row>
        <div class="type_box">
            <!-- <span style="padding: 9px 15px;margin-right: 10px;">题型</span> -->
            <span class="trem" v-show="item.value != 8" v-for="(item,index) in type_data" :key="index" @click="clickType(item.value)" :style="change_index == item.value?'background-color:#409eff;color:#ffffff':''">{{ item.name }}</span>
        </div>
        <el-table
            ref="multipleTable_"
            :data="tableData"
            tooltip-effect="dark"
            highlight-selection-row
            row-key="id"
            style="width: 100%;cursor: pointer;margin-top: 20px;display: inline-block;"
            @selection-change="handleSelectionChange"
            >
            <el-table-column
            type="selection"
            width="55">
            </el-table-column>
            <el-table-column
                prop="title"
                label="标题">
            </el-table-column>
            <el-table-column
                prop="type_text"
                label="题型"
                width="150">
            </el-table-column>
            <el-table-column
                prop="number"
                label="题量"
                width="150">
            </el-table-column>
            <el-table-column
                prop="uname"
                label="创建人"
                width="150">
            </el-table-column>
            <el-table-column
                prop="createtime_text"
                label="时间"
                width="150">
            </el-table-column>
            <el-table-column width="150" label="操作">
                <template slot-scope="scope">

                    <el-button
                    size="mini"
                    @click="handleRowClick(scope.row)">查看</el-button>

                    <el-button
                    size="mini"
                    v-if="trem"
                    type="primary"
                    @click="handleRowClick(scope.row)">选择</el-button>

                </template>
            </el-table-column>
        </el-table>
    </layout>
</template>
<script>
import TitleLable from '../../units/Titlelabel.vue';
import Http from "../../apis/questionbank";
export default {
    components:{
        TitleLable
    },
    data(){
        return{
            tableData:[],
            question_id:'',
            total_number:0,
            question_ids:[],
            trem:'',
            change_index:1,
            grade:'',
            type_data:[
                {
                    value:1,
                    name:'单项选择'
                },
                {
                    value:2,
                    name:'阅读理解'
                },
                {
                    value:3,
                    name:'完型填空'
                },
                {
                    value:4,
                    name:'匹配题'
                },
                {
                    value:5,
                    name:'单词变形'
                },
                {
                    value:6,
                    name:'写作题'
                },
                {
                    value:7,
                    name:'翻译题'
                },
                {
                    value:8,
                    name:'听力题'
                },
                {
                    value:9,
                    name:'判断题'
                }
            ],
        }
    },
    activated(){
        this.question_id = this.$route.query.id
        this.trem = this.$route.query.trem
        this.grade = this.$route.query.grade
        this.getlist()
    },
    methods:{
        clickType(value){
            this.change_index = value

            this.getlist();
        },
        getlist(){
            var params = {}
            params.qid = this.question_id
            params.type = this.change_index
            Http.material(params).then((res) => {
                
                this.tableData = res.data.data
                this.total_number = res.data.total_number
            });
        },
        confirmChange(){
           
           var question_ids = this.question_ids.join(',')
           localStorage.setItem('question_ids', question_ids);
           this.$refs.multipleTable_.clearSelection();
           this.$router.push({ name: 'Createpaper',query:{type:this.change_index,bank_index:2,trem:this.trem,grade:this.grade}});
       },
        handleRowClick(item){
            var question_ids = item.id
            localStorage.setItem('question_ids', question_ids);
      
            this.$router.push({ name: 'Createpaper',query:{type:item.type,bank_index:2,trem:this.trem,grade:this.grade}});
        },
        handleSelectionChange(e){
            var row = []
            for(var i in e){
                row.push(e[i].id)
            }
            this.question_ids = row
        },
        createQuestion(){
            this.$router.push({ name: 'Createquestion',query:{question_id:this.question_id}});
        }
    }
}
</script>
<style lang="less" scoped>
.type_box{

    display: inline-block;
    width: 100%;
    margin-top: 20px;
}
.trem{
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
</style>